@file:OptIn(InternalResourceApi::class)

package mobile_wallet.feature.accounts.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/mobile_wallet.feature.accounts.generated.resources/"

internal val Res.string.delete_beneficiary_subtitle: StringResource by lazy {
      StringResource("string:delete_beneficiary_subtitle", "delete_beneficiary_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 103),
      ))
    }

internal val Res.string.delete_beneficiary_title: StringResource by lazy {
      StringResource("string:delete_beneficiary_title", "delete_beneficiary_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 114, 56),
      ))
    }

internal val Res.string.feature_accounts_ac_holder_name: StringResource by lazy {
      StringResource("string:feature_accounts_ac_holder_name", "feature_accounts_ac_holder_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 171, 59),
      ))
    }

internal val Res.string.feature_accounts_add: StringResource by lazy {
      StringResource("string:feature_accounts_add", "feature_accounts_add", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1607, 32),
      ))
    }

internal val Res.string.feature_accounts_add_account: StringResource by lazy {
      StringResource("string:feature_accounts_add_account", "feature_accounts_add_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 231, 52),
      ))
    }

internal val Res.string.feature_accounts_add_allow_overdraft: StringResource by lazy {
      StringResource("string:feature_accounts_add_allow_overdraft", "feature_accounts_add_allow_overdraft", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 284, 64),
      ))
    }

internal val Res.string.feature_accounts_add_beneficiary: StringResource by lazy {
      StringResource("string:feature_accounts_add_beneficiary", "feature_accounts_add_beneficiary", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 514, 60),
      ))
    }

internal val Res.string.feature_accounts_add_beneficiary_hint: StringResource by lazy {
      StringResource("string:feature_accounts_add_beneficiary_hint", "feature_accounts_add_beneficiary_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 349, 97),
      ))
    }

internal val Res.string.feature_accounts_add_beneficiary_title: StringResource by lazy {
      StringResource("string:feature_accounts_add_beneficiary_title", "feature_accounts_add_beneficiary_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 447, 66),
      ))
    }

internal val Res.string.feature_accounts_add_cards: StringResource by lazy {
      StringResource("string:feature_accounts_add_cards", "feature_accounts_add_cards", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 575, 58),
      ))
    }

internal val Res.string.feature_accounts_add_client_name: StringResource by lazy {
      StringResource("string:feature_accounts_add_client_name", "feature_accounts_add_client_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 634, 56),
      ))
    }

internal val Res.string.feature_accounts_add_date_format: StringResource by lazy {
      StringResource("string:feature_accounts_add_date_format", "feature_accounts_add_date_format", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 691, 56),
      ))
    }

internal val Res.string.feature_accounts_add_external_id: StringResource by lazy {
      StringResource("string:feature_accounts_add_external_id", "feature_accounts_add_external_id", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 748, 56),
      ))
    }

internal val Res.string.feature_accounts_add_locale: StringResource by lazy {
      StringResource("string:feature_accounts_add_locale", "feature_accounts_add_locale", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 805, 43),
      ))
    }

internal val Res.string.feature_accounts_add_min_required_balance: StringResource by lazy {
      StringResource("string:feature_accounts_add_min_required_balance", "feature_accounts_add_min_required_balance", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 849, 77),
      ))
    }

internal val Res.string.feature_accounts_add_nominal_annual: StringResource by lazy {
      StringResource("string:feature_accounts_add_nominal_annual", "feature_accounts_add_nominal_annual", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 927, 83),
      ))
    }

internal val Res.string.feature_accounts_add_opening_balance: StringResource by lazy {
      StringResource("string:feature_accounts_add_opening_balance", "feature_accounts_add_opening_balance", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1011, 64),
      ))
    }

internal val Res.string.feature_accounts_add_overdraft_limit: StringResource by lazy {
      StringResource("string:feature_accounts_add_overdraft_limit", "feature_accounts_add_overdraft_limit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1076, 64),
      ))
    }

internal val Res.string.feature_accounts_add_product_name: StringResource by lazy {
      StringResource("string:feature_accounts_add_product_name", "feature_accounts_add_product_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1141, 57),
      ))
    }

internal val Res.string.feature_accounts_add_saving_product: StringResource by lazy {
      StringResource("string:feature_accounts_add_saving_product", "feature_accounts_add_saving_product", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1199, 63),
      ))
    }

internal val Res.string.feature_accounts_add_savings_account: StringResource by lazy {
      StringResource("string:feature_accounts_add_savings_account", "feature_accounts_add_savings_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1263, 72),
      ))
    }

internal val Res.string.feature_accounts_add_submit_account: StringResource by lazy {
      StringResource("string:feature_accounts_add_submit_account", "feature_accounts_add_submit_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1336, 63),
      ))
    }

internal val Res.string.feature_accounts_add_submitted_date: StringResource by lazy {
      StringResource("string:feature_accounts_add_submitted_date", "feature_accounts_add_submitted_date", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1400, 63),
      ))
    }

internal val Res.string.feature_accounts_add_with_hold_tax: StringResource by lazy {
      StringResource("string:feature_accounts_add_with_hold_tax", "feature_accounts_add_with_hold_tax", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1464, 62),
      ))
    }

internal val Res.string.feature_accounts_add_withdrawal_fee: StringResource by lazy {
      StringResource("string:feature_accounts_add_withdrawal_fee", "feature_accounts_add_withdrawal_fee", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1527, 79),
      ))
    }

internal val Res.string.feature_accounts_bank_account_details: StringResource by lazy {
      StringResource("string:feature_accounts_bank_account_details", "feature_accounts_bank_account_details", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1640, 73),
      ))
    }

internal val Res.string.feature_accounts_bank_account_mobile_verification_conditions: StringResource
    by lazy {
      StringResource("string:feature_accounts_bank_account_mobile_verification_conditions", "feature_accounts_bank_account_mobile_verification_conditions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1714, 344),
      ))
    }

internal val Res.string.feature_accounts_bank_name: StringResource by lazy {
      StringResource("string:feature_accounts_bank_name", "feature_accounts_bank_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2059, 46),
      ))
    }

internal val Res.string.feature_accounts_beneficiaries: StringResource by lazy {
      StringResource("string:feature_accounts_beneficiaries", "feature_accounts_beneficiaries", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2106, 58),
      ))
    }

internal val Res.string.feature_accounts_beneficiary_account_no: StringResource by lazy {
      StringResource("string:feature_accounts_beneficiary_account_no", "feature_accounts_beneficiary_account_no", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2165, 63),
      ))
    }

internal val Res.string.feature_accounts_beneficiary_account_number: StringResource by lazy {
      StringResource("string:feature_accounts_beneficiary_account_number", "feature_accounts_beneficiary_account_number", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2229, 87),
      ))
    }

internal val Res.string.feature_accounts_beneficiary_account_type: StringResource by lazy {
      StringResource("string:feature_accounts_beneficiary_account_type", "feature_accounts_beneficiary_account_type", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2446, 65),
      ))
    }

internal val Res.string.feature_accounts_beneficiary_account_type_other: StringResource by lazy {
      StringResource("string:feature_accounts_beneficiary_account_type_other", "feature_accounts_beneficiary_account_type_other", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2317, 63),
      ))
    }

internal val Res.string.feature_accounts_beneficiary_account_type_wallet: StringResource by lazy {
      StringResource("string:feature_accounts_beneficiary_account_type_wallet", "feature_accounts_beneficiary_account_type_wallet", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2381, 64),
      ))
    }

internal val Res.string.feature_accounts_beneficiary_added: StringResource by lazy {
      StringResource("string:feature_accounts_beneficiary_added", "feature_accounts_beneficiary_added", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2512, 66),
      ))
    }

internal val Res.string.feature_accounts_beneficiary_button_save: StringResource by lazy {
      StringResource("string:feature_accounts_beneficiary_button_save", "feature_accounts_beneficiary_button_save", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2579, 56),
      ))
    }

internal val Res.string.feature_accounts_beneficiary_button_update: StringResource by lazy {
      StringResource("string:feature_accounts_beneficiary_button_update", "feature_accounts_beneficiary_button_update", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2636, 58),
      ))
    }

internal val Res.string.feature_accounts_beneficiary_deleted: StringResource by lazy {
      StringResource("string:feature_accounts_beneficiary_deleted", "feature_accounts_beneficiary_deleted", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2695, 72),
      ))
    }

internal val Res.string.feature_accounts_beneficiary_locale: StringResource by lazy {
      StringResource("string:feature_accounts_beneficiary_locale", "feature_accounts_beneficiary_locale", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2768, 51),
      ))
    }

internal val Res.string.feature_accounts_beneficiary_name: StringResource by lazy {
      StringResource("string:feature_accounts_beneficiary_name", "feature_accounts_beneficiary_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2820, 65),
      ))
    }

internal val Res.string.feature_accounts_beneficiary_nickname: StringResource by lazy {
      StringResource("string:feature_accounts_beneficiary_nickname", "feature_accounts_beneficiary_nickname", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2886, 57),
      ))
    }

internal val Res.string.feature_accounts_beneficiary_office_name: StringResource by lazy {
      StringResource("string:feature_accounts_beneficiary_office_name", "feature_accounts_beneficiary_office_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2944, 64),
      ))
    }

internal val Res.string.feature_accounts_beneficiary_save: StringResource by lazy {
      StringResource("string:feature_accounts_beneficiary_save", "feature_accounts_beneficiary_save", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3009, 49),
      ))
    }

internal val Res.string.feature_accounts_beneficiary_title_add: StringResource by lazy {
      StringResource("string:feature_accounts_beneficiary_title_add", "feature_accounts_beneficiary_title_add", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3059, 66),
      ))
    }

internal val Res.string.feature_accounts_beneficiary_title_update: StringResource by lazy {
      StringResource("string:feature_accounts_beneficiary_title_update", "feature_accounts_beneficiary_title_update", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3126, 73),
      ))
    }

internal val Res.string.feature_accounts_beneficiary_transfer_limit: StringResource by lazy {
      StringResource("string:feature_accounts_beneficiary_transfer_limit", "feature_accounts_beneficiary_transfer_limit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3200, 71),
      ))
    }

internal val Res.string.feature_accounts_beneficiary_updated: StringResource by lazy {
      StringResource("string:feature_accounts_beneficiary_updated", "feature_accounts_beneficiary_updated", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3272, 72),
      ))
    }

internal val Res.string.feature_accounts_branch_name: StringResource by lazy {
      StringResource("string:feature_accounts_branch_name", "feature_accounts_branch_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3345, 52),
      ))
    }

internal val Res.string.feature_accounts_change_upi_pin: StringResource by lazy {
      StringResource("string:feature_accounts_change_upi_pin", "feature_accounts_change_upi_pin", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3398, 59),
      ))
    }

internal val Res.string.feature_accounts_check: StringResource by lazy {
      StringResource("string:feature_accounts_check", "feature_accounts_check", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3458, 38),
      ))
    }

internal val Res.string.feature_accounts_choose_a_sim: StringResource by lazy {
      StringResource("string:feature_accounts_choose_a_sim", "feature_accounts_choose_a_sim", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3497, 65),
      ))
    }

internal val Res.string.feature_accounts_confirm: StringResource by lazy {
      StringResource("string:feature_accounts_confirm", "feature_accounts_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3734, 44),
      ))
    }

internal val Res.string.feature_accounts_confirm_mobile_number_message: StringResource by lazy {
      StringResource("string:feature_accounts_confirm_mobile_number_message", "feature_accounts_confirm_mobile_number_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3563, 170),
      ))
    }

internal val Res.string.feature_accounts_default: StringResource by lazy {
      StringResource("string:feature_accounts_default", "feature_accounts_default", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3860, 44),
      ))
    }

internal val Res.string.feature_accounts_default_account_updated: StringResource by lazy {
      StringResource("string:feature_accounts_default_account_updated", "feature_accounts_default_account_updated", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3779, 80),
      ))
    }

internal val Res.string.feature_accounts_delete_bank: StringResource by lazy {
      StringResource("string:feature_accounts_delete_bank", "feature_accounts_delete_bank", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3905, 52),
      ))
    }

internal val Res.string.feature_accounts_delete_beneficiary: StringResource by lazy {
      StringResource("string:feature_accounts_delete_beneficiary", "feature_accounts_delete_beneficiary", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3958, 67),
      ))
    }

internal val Res.string.feature_accounts_detail_account_balance: StringResource by lazy {
      StringResource("string:feature_accounts_detail_account_balance", "feature_accounts_detail_account_balance", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4026, 67),
      ))
    }

internal val Res.string.feature_accounts_detail_account_details: StringResource by lazy {
      StringResource("string:feature_accounts_detail_account_details", "feature_accounts_detail_account_details", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4094, 67),
      ))
    }

internal val Res.string.feature_accounts_detail_account_summary: StringResource by lazy {
      StringResource("string:feature_accounts_detail_account_summary", "feature_accounts_detail_account_summary", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4162, 67),
      ))
    }

internal val Res.string.feature_accounts_detail_arrow: StringResource by lazy {
      StringResource("string:feature_accounts_detail_arrow", "feature_accounts_detail_arrow", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4230, 45),
      ))
    }

internal val Res.string.feature_accounts_detail_available_balance: StringResource by lazy {
      StringResource("string:feature_accounts_detail_available_balance", "feature_accounts_detail_available_balance", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4276, 73),
      ))
    }

internal val Res.string.feature_accounts_detail_interest_not_posted: StringResource by lazy {
      StringResource("string:feature_accounts_detail_interest_not_posted", "feature_accounts_detail_interest_not_posted", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4350, 79),
      ))
    }

internal val Res.string.feature_accounts_detail_product_name: StringResource by lazy {
      StringResource("string:feature_accounts_detail_product_name", "feature_accounts_detail_product_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4430, 60),
      ))
    }

internal val Res.string.feature_accounts_detail_total_deposits: StringResource by lazy {
      StringResource("string:feature_accounts_detail_total_deposits", "feature_accounts_detail_total_deposits", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4491, 66),
      ))
    }

internal val Res.string.feature_accounts_detail_total_interest_posted: StringResource by lazy {
      StringResource("string:feature_accounts_detail_total_interest_posted", "feature_accounts_detail_total_interest_posted", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4558, 81),
      ))
    }

internal val Res.string.feature_accounts_detail_total_overdraft: StringResource by lazy {
      StringResource("string:feature_accounts_detail_total_overdraft", "feature_accounts_detail_total_overdraft", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4640, 67),
      ))
    }

internal val Res.string.feature_accounts_detail_total_withdrawals: StringResource by lazy {
      StringResource("string:feature_accounts_detail_total_withdrawals", "feature_accounts_detail_total_withdrawals", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4708, 73),
      ))
    }

internal val Res.string.feature_accounts_detail_wallet_balance: StringResource by lazy {
      StringResource("string:feature_accounts_detail_wallet_balance", "feature_accounts_detail_wallet_balance", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4782, 66),
      ))
    }

internal val Res.string.feature_accounts_edit: StringResource by lazy {
      StringResource("string:feature_accounts_edit", "feature_accounts_edit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5061, 37),
      ))
    }

internal val Res.string.feature_accounts_edit_beneficiary: StringResource by lazy {
      StringResource("string:feature_accounts_edit_beneficiary", "feature_accounts_edit_beneficiary", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4921, 65),
      ))
    }

internal val Res.string.feature_accounts_edit_beneficiary_title: StringResource by lazy {
      StringResource("string:feature_accounts_edit_beneficiary_title", "feature_accounts_edit_beneficiary_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4849, 71),
      ))
    }

internal val Res.string.feature_accounts_edit_savings_account: StringResource by lazy {
      StringResource("string:feature_accounts_edit_savings_account", "feature_accounts_edit_savings_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4987, 73),
      ))
    }

internal val Res.string.feature_accounts_error_account_id_required: StringResource by lazy {
      StringResource("string:feature_accounts_error_account_id_required", "feature_accounts_error_account_id_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5099, 118),
      ))
    }

internal val Res.string.feature_accounts_error_client_id_required: StringResource by lazy {
      StringResource("string:feature_accounts_error_client_id_required", "feature_accounts_error_client_id_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5218, 77),
      ))
    }

internal val Res.string.feature_accounts_error_date_format_required: StringResource by lazy {
      StringResource("string:feature_accounts_error_date_format_required", "feature_accounts_error_date_format_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5296, 83),
      ))
    }

internal val Res.string.feature_accounts_error_empty_account_number: StringResource by lazy {
      StringResource("string:feature_accounts_error_empty_account_number", "feature_accounts_error_empty_account_number", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5380, 91),
      ))
    }

internal val Res.string.feature_accounts_error_empty_beneficiary_name: StringResource by lazy {
      StringResource("string:feature_accounts_error_empty_beneficiary_name", "feature_accounts_error_empty_beneficiary_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5472, 97),
      ))
    }

internal val Res.string.feature_accounts_error_empty_office_name: StringResource by lazy {
      StringResource("string:feature_accounts_error_empty_office_name", "feature_accounts_error_empty_office_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5570, 84),
      ))
    }

internal val Res.string.feature_accounts_error_external_id_length: StringResource by lazy {
      StringResource("string:feature_accounts_error_external_id_length", "feature_accounts_error_external_id_length", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5655, 105),
      ))
    }

internal val Res.string.feature_accounts_error_external_id_required: StringResource by lazy {
      StringResource("string:feature_accounts_error_external_id_required", "feature_accounts_error_external_id_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5761, 83),
      ))
    }

internal val Res.string.feature_accounts_error_invalid_transfer_limit: StringResource by lazy {
      StringResource("string:feature_accounts_error_invalid_transfer_limit", "feature_accounts_error_invalid_transfer_limit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5845, 105),
      ))
    }

internal val Res.string.feature_accounts_error_locale_required: StringResource by lazy {
      StringResource("string:feature_accounts_error_locale_required", "feature_accounts_error_locale_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5951, 70),
      ))
    }

internal val Res.string.feature_accounts_error_min_opening_balance_required: StringResource by
    lazy {
      StringResource("string:feature_accounts_error_min_opening_balance_required", "feature_accounts_error_min_opening_balance_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6022, 115),
      ))
    }

internal val Res.string.feature_accounts_error_oops: StringResource by lazy {
      StringResource("string:feature_accounts_error_oops", "feature_accounts_error_oops", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6138, 43),
      ))
    }

internal val Res.string.feature_accounts_error_overdraft_limit_required: StringResource by lazy {
      StringResource("string:feature_accounts_error_overdraft_limit_required", "feature_accounts_error_overdraft_limit_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6182, 91),
      ))
    }

internal val Res.string.feature_accounts_error_select_account_type: StringResource by lazy {
      StringResource("string:feature_accounts_error_select_account_type", "feature_accounts_error_select_account_type", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6274, 82),
      ))
    }

internal val Res.string.feature_accounts_error_select_locale: StringResource by lazy {
      StringResource("string:feature_accounts_error_select_locale", "feature_accounts_error_select_locale", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6357, 64),
      ))
    }

internal val Res.string.feature_accounts_error_select_saving_product: StringResource by lazy {
      StringResource("string:feature_accounts_error_select_saving_product", "feature_accounts_error_select_saving_product", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6422, 84),
      ))
    }

internal val Res.string.feature_accounts_error_submitted_date_required: StringResource by lazy {
      StringResource("string:feature_accounts_error_submitted_date_required", "feature_accounts_error_submitted_date_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6507, 94),
      ))
    }

internal val Res.string.feature_accounts_forgot_upi_pin: StringResource by lazy {
      StringResource("string:feature_accounts_forgot_upi_pin", "feature_accounts_forgot_upi_pin", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6602, 59),
      ))
    }

internal val Res.string.feature_accounts_ifsc: StringResource by lazy {
      StringResource("string:feature_accounts_ifsc", "feature_accounts_ifsc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6662, 37),
      ))
    }

internal val Res.string.feature_accounts_info: StringResource by lazy {
      StringResource("string:feature_accounts_info", "feature_accounts_info", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6700, 37),
      ))
    }

internal val Res.string.feature_accounts_link_bank_account: StringResource by lazy {
      StringResource("string:feature_accounts_link_bank_account", "feature_accounts_link_bank_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6738, 66),
      ))
    }

internal val Res.string.feature_accounts_linked_bank_account: StringResource by lazy {
      StringResource("string:feature_accounts_linked_bank_account", "feature_accounts_linked_bank_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6805, 72),
      ))
    }

internal val Res.string.feature_accounts_loading: StringResource by lazy {
      StringResource("string:feature_accounts_loading", "feature_accounts_loading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6878, 44),
      ))
    }

internal val Res.string.feature_accounts_no_beneficiaries: StringResource by lazy {
      StringResource("string:feature_accounts_no_beneficiaries", "feature_accounts_no_beneficiaries", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6923, 65),
      ))
    }

internal val Res.string.feature_accounts_no_linked_bank_accounts: StringResource by lazy {
      StringResource("string:feature_accounts_no_linked_bank_accounts", "feature_accounts_no_linked_bank_accounts", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6989, 80),
      ))
    }

internal val Res.string.feature_accounts_or: StringResource by lazy {
      StringResource("string:feature_accounts_or", "feature_accounts_or", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7070, 31),
      ))
    }

internal val Res.string.feature_accounts_other_banks: StringResource by lazy {
      StringResource("string:feature_accounts_other_banks", "feature_accounts_other_banks", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7102, 52),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("delete_beneficiary_subtitle", Res.string.delete_beneficiary_subtitle)
  map.put("delete_beneficiary_title", Res.string.delete_beneficiary_title)
  map.put("feature_accounts_ac_holder_name", Res.string.feature_accounts_ac_holder_name)
  map.put("feature_accounts_add", Res.string.feature_accounts_add)
  map.put("feature_accounts_add_account", Res.string.feature_accounts_add_account)
  map.put("feature_accounts_add_allow_overdraft", Res.string.feature_accounts_add_allow_overdraft)
  map.put("feature_accounts_add_beneficiary", Res.string.feature_accounts_add_beneficiary)
  map.put("feature_accounts_add_beneficiary_hint", Res.string.feature_accounts_add_beneficiary_hint)
  map.put("feature_accounts_add_beneficiary_title", Res.string.feature_accounts_add_beneficiary_title)
  map.put("feature_accounts_add_cards", Res.string.feature_accounts_add_cards)
  map.put("feature_accounts_add_client_name", Res.string.feature_accounts_add_client_name)
  map.put("feature_accounts_add_date_format", Res.string.feature_accounts_add_date_format)
  map.put("feature_accounts_add_external_id", Res.string.feature_accounts_add_external_id)
  map.put("feature_accounts_add_locale", Res.string.feature_accounts_add_locale)
  map.put("feature_accounts_add_min_required_balance", Res.string.feature_accounts_add_min_required_balance)
  map.put("feature_accounts_add_nominal_annual", Res.string.feature_accounts_add_nominal_annual)
  map.put("feature_accounts_add_opening_balance", Res.string.feature_accounts_add_opening_balance)
  map.put("feature_accounts_add_overdraft_limit", Res.string.feature_accounts_add_overdraft_limit)
  map.put("feature_accounts_add_product_name", Res.string.feature_accounts_add_product_name)
  map.put("feature_accounts_add_saving_product", Res.string.feature_accounts_add_saving_product)
  map.put("feature_accounts_add_savings_account", Res.string.feature_accounts_add_savings_account)
  map.put("feature_accounts_add_submit_account", Res.string.feature_accounts_add_submit_account)
  map.put("feature_accounts_add_submitted_date", Res.string.feature_accounts_add_submitted_date)
  map.put("feature_accounts_add_with_hold_tax", Res.string.feature_accounts_add_with_hold_tax)
  map.put("feature_accounts_add_withdrawal_fee", Res.string.feature_accounts_add_withdrawal_fee)
  map.put("feature_accounts_bank_account_details", Res.string.feature_accounts_bank_account_details)
  map.put("feature_accounts_bank_account_mobile_verification_conditions", Res.string.feature_accounts_bank_account_mobile_verification_conditions)
  map.put("feature_accounts_bank_name", Res.string.feature_accounts_bank_name)
  map.put("feature_accounts_beneficiaries", Res.string.feature_accounts_beneficiaries)
  map.put("feature_accounts_beneficiary_account_no", Res.string.feature_accounts_beneficiary_account_no)
  map.put("feature_accounts_beneficiary_account_number", Res.string.feature_accounts_beneficiary_account_number)
  map.put("feature_accounts_beneficiary_account_type", Res.string.feature_accounts_beneficiary_account_type)
  map.put("feature_accounts_beneficiary_account_type_other", Res.string.feature_accounts_beneficiary_account_type_other)
  map.put("feature_accounts_beneficiary_account_type_wallet", Res.string.feature_accounts_beneficiary_account_type_wallet)
  map.put("feature_accounts_beneficiary_added", Res.string.feature_accounts_beneficiary_added)
  map.put("feature_accounts_beneficiary_button_save", Res.string.feature_accounts_beneficiary_button_save)
  map.put("feature_accounts_beneficiary_button_update", Res.string.feature_accounts_beneficiary_button_update)
  map.put("feature_accounts_beneficiary_deleted", Res.string.feature_accounts_beneficiary_deleted)
  map.put("feature_accounts_beneficiary_locale", Res.string.feature_accounts_beneficiary_locale)
  map.put("feature_accounts_beneficiary_name", Res.string.feature_accounts_beneficiary_name)
  map.put("feature_accounts_beneficiary_nickname", Res.string.feature_accounts_beneficiary_nickname)
  map.put("feature_accounts_beneficiary_office_name", Res.string.feature_accounts_beneficiary_office_name)
  map.put("feature_accounts_beneficiary_save", Res.string.feature_accounts_beneficiary_save)
  map.put("feature_accounts_beneficiary_title_add", Res.string.feature_accounts_beneficiary_title_add)
  map.put("feature_accounts_beneficiary_title_update", Res.string.feature_accounts_beneficiary_title_update)
  map.put("feature_accounts_beneficiary_transfer_limit", Res.string.feature_accounts_beneficiary_transfer_limit)
  map.put("feature_accounts_beneficiary_updated", Res.string.feature_accounts_beneficiary_updated)
  map.put("feature_accounts_branch_name", Res.string.feature_accounts_branch_name)
  map.put("feature_accounts_change_upi_pin", Res.string.feature_accounts_change_upi_pin)
  map.put("feature_accounts_check", Res.string.feature_accounts_check)
  map.put("feature_accounts_choose_a_sim", Res.string.feature_accounts_choose_a_sim)
  map.put("feature_accounts_confirm", Res.string.feature_accounts_confirm)
  map.put("feature_accounts_confirm_mobile_number_message", Res.string.feature_accounts_confirm_mobile_number_message)
  map.put("feature_accounts_default", Res.string.feature_accounts_default)
  map.put("feature_accounts_default_account_updated", Res.string.feature_accounts_default_account_updated)
  map.put("feature_accounts_delete_bank", Res.string.feature_accounts_delete_bank)
  map.put("feature_accounts_delete_beneficiary", Res.string.feature_accounts_delete_beneficiary)
  map.put("feature_accounts_detail_account_balance", Res.string.feature_accounts_detail_account_balance)
  map.put("feature_accounts_detail_account_details", Res.string.feature_accounts_detail_account_details)
  map.put("feature_accounts_detail_account_summary", Res.string.feature_accounts_detail_account_summary)
  map.put("feature_accounts_detail_arrow", Res.string.feature_accounts_detail_arrow)
  map.put("feature_accounts_detail_available_balance", Res.string.feature_accounts_detail_available_balance)
  map.put("feature_accounts_detail_interest_not_posted", Res.string.feature_accounts_detail_interest_not_posted)
  map.put("feature_accounts_detail_product_name", Res.string.feature_accounts_detail_product_name)
  map.put("feature_accounts_detail_total_deposits", Res.string.feature_accounts_detail_total_deposits)
  map.put("feature_accounts_detail_total_interest_posted", Res.string.feature_accounts_detail_total_interest_posted)
  map.put("feature_accounts_detail_total_overdraft", Res.string.feature_accounts_detail_total_overdraft)
  map.put("feature_accounts_detail_total_withdrawals", Res.string.feature_accounts_detail_total_withdrawals)
  map.put("feature_accounts_detail_wallet_balance", Res.string.feature_accounts_detail_wallet_balance)
  map.put("feature_accounts_edit", Res.string.feature_accounts_edit)
  map.put("feature_accounts_edit_beneficiary", Res.string.feature_accounts_edit_beneficiary)
  map.put("feature_accounts_edit_beneficiary_title", Res.string.feature_accounts_edit_beneficiary_title)
  map.put("feature_accounts_edit_savings_account", Res.string.feature_accounts_edit_savings_account)
  map.put("feature_accounts_error_account_id_required", Res.string.feature_accounts_error_account_id_required)
  map.put("feature_accounts_error_client_id_required", Res.string.feature_accounts_error_client_id_required)
  map.put("feature_accounts_error_date_format_required", Res.string.feature_accounts_error_date_format_required)
  map.put("feature_accounts_error_empty_account_number", Res.string.feature_accounts_error_empty_account_number)
  map.put("feature_accounts_error_empty_beneficiary_name", Res.string.feature_accounts_error_empty_beneficiary_name)
  map.put("feature_accounts_error_empty_office_name", Res.string.feature_accounts_error_empty_office_name)
  map.put("feature_accounts_error_external_id_length", Res.string.feature_accounts_error_external_id_length)
  map.put("feature_accounts_error_external_id_required", Res.string.feature_accounts_error_external_id_required)
  map.put("feature_accounts_error_invalid_transfer_limit", Res.string.feature_accounts_error_invalid_transfer_limit)
  map.put("feature_accounts_error_locale_required", Res.string.feature_accounts_error_locale_required)
  map.put("feature_accounts_error_min_opening_balance_required", Res.string.feature_accounts_error_min_opening_balance_required)
  map.put("feature_accounts_error_oops", Res.string.feature_accounts_error_oops)
  map.put("feature_accounts_error_overdraft_limit_required", Res.string.feature_accounts_error_overdraft_limit_required)
  map.put("feature_accounts_error_select_account_type", Res.string.feature_accounts_error_select_account_type)
  map.put("feature_accounts_error_select_locale", Res.string.feature_accounts_error_select_locale)
  map.put("feature_accounts_error_select_saving_product", Res.string.feature_accounts_error_select_saving_product)
  map.put("feature_accounts_error_submitted_date_required", Res.string.feature_accounts_error_submitted_date_required)
  map.put("feature_accounts_forgot_upi_pin", Res.string.feature_accounts_forgot_upi_pin)
  map.put("feature_accounts_ifsc", Res.string.feature_accounts_ifsc)
  map.put("feature_accounts_info", Res.string.feature_accounts_info)
  map.put("feature_accounts_link_bank_account", Res.string.feature_accounts_link_bank_account)
  map.put("feature_accounts_linked_bank_account", Res.string.feature_accounts_linked_bank_account)
  map.put("feature_accounts_loading", Res.string.feature_accounts_loading)
  map.put("feature_accounts_no_beneficiaries", Res.string.feature_accounts_no_beneficiaries)
  map.put("feature_accounts_no_linked_bank_accounts", Res.string.feature_accounts_no_linked_bank_accounts)
  map.put("feature_accounts_or", Res.string.feature_accounts_or)
  map.put("feature_accounts_other_banks", Res.string.feature_accounts_other_banks)
}
